import React, { Component } from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';
import Committees from './containers/committees-component';

export default class CommitteeList extends Component {
	componentDidMount() {
		let reactWrapper = document.querySelector( '.react-fallback' );
		if ( reactWrapper.classList ) {
			reactWrapper.classList.add( 'visible-delay' );
		} else {
			reactWrapper.className += ' ' + 'visible-delay';
		}
	}

	render() {
		return (<Provider store={ store }>
				<div>
					<Committees />
				</div>
			</Provider>
		);
	}
}

var CommitteeListElement = document.getElementById( 'commmittee-list' );
if ( CommitteeListElement ) {
	ReactDom.render( <CommitteeList />, CommitteeListElement );
}
